<template>
  <el-dialog title="账户设置" @open="dialogOpen" width="400px" :visible.sync="dialogControl.dialogVisible" append-to-body>
    <el-container v-loading="loading">
      <el-main >
        <el-form  style="margin-top:10px;" :model="formTemp" status-icon :rules="rules" ref="ruleForm" label-width="80px">
          <el-form-item label="姓名" prop="userName">
            <el-input  v-model="formTemp.userName" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-radio-group v-model="formTemp.sex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="邮箱地址" prop="mailAddress">
            <el-input v-model="formTemp.mailAddress" placeholder="请输入邮箱地址"></el-input>
          </el-form-item>
          <el-form-item label="传真地址">
            <el-input  v-model="formTemp.faxAddress" placeholder="请输入传真地址"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="mobilePhone">
            <el-input  v-model="formTemp.mobilePhone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="电话号码">
            <el-input  v-model="formTemp.telephone" placeholder="请输入电话号码"></el-input>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
    <div slot="footer" class="dialog-footer">
        <el-button @click="dialogControl.dialogVisible = false;">取 消</el-button>
        <el-button type="primary"  @click="saveUser">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { saveOrUpdateUser, getUserById } from '@/api/user/user'
import { validateEmail, validateMobilePhone } from '@/utils/validate'
import { mapGetters } from 'vuex'
export default {
  name: 'AccountInfo',
  components: { },
  props: {
    dialogControl: {
      type: Object,
      default: function() {
        return { dialogVisible: false }
      }
    }
  },
  data() {
    // 邮箱校验
    var validateEmailFun = (rule, value, callback) => {
      if (value == null || value === '') {
        callback()
      }
      if (!validateEmail(value)) {
        callback(new Error('请输入正确的邮箱'))
      } else {
        callback()
      }
    }
    // 手机号校验
    var validateMPhone = (rule, value, callback) => {
      if (value == null || value === '') {
        callback()
      }
      if (!validateMobilePhone(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      rules: {
        userName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        mailAddress: [
          { validator: validateEmailFun, trigger: 'blur' }
        ],
        mobilePhone: [
          { validator: validateMPhone, trigger: 'blur' },
          { min: 11, max: 11, message: '手机号长度为11位', trigger: 'blur' }
        ]
      },
      formTemp: { userName: '', sex: 0, mailAddress: '', faxAddress: '', mobilePhone: '', telephone: '' }
    }
  },
  computed: {
    ...mapGetters([
      'userId'])
  },
  methods: {
    dialogOpen() {
      this.loading = true
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      getUserById({ id: this.userId }).then(response => {
        const data = response.data.result
        this.formTemp.id = data.id
        this.formTemp.userName = data.userName
        this.formTemp.sex = data.sex
        this.formTemp.mailAddress = data.mailAddress
        this.formTemp.faxAddress = data.faxAddress
        this.formTemp.mobilePhone = data.mobilePhone
        this.formTemp.telephone = data.telephone
        this.loading = false
      })
    },
    // 保存用户
    saveUser() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          saveOrUpdateUser({ ...this.formTemp, id: this.userId }).then(response => {
            this.loading = false
            if (response.data.result.success) {
              this.$store.dispatch('ChangeUserName', this.formTemp.userName)
              this.dialogControl.dialogVisible = false
              this.$notify({ title: '成功', message: '账户设置保存成功', type: 'success', position: 'bottom-right' })
            } else {
              this.$notify({ title: '警告', message: response.data.result.message, type: 'warning', position: 'bottom-right' })
            }
          }).catch(response => {})
        } else {
          this.$message({ message: '请完善信息', type: 'warning', duration: 1000 })
          return false
        }
      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Account/AccountInfo.vue